<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5>Novo Cliente/Contato</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <form [formGroup]="formCadastrar" id="formCadastrar">
        <div class="row">
          <div class="form-group col-md-12">
            <label for="nomeSolicitante">Cliente/Empresa</label>
            <input type="text" id="nomeSolicitante"
                   placeholder="Digite o nome do cliente/empresa."
                   [ngClass]="{'is-invalid': formCadastrar.get('nome')?.errors && formCadastrar.get('nome')?.touched}"
                   formControlName="nome" class="form-control">
          </div>
          <div class="form-group col-md-5">
            <label for="tipoDocumentoId">Tipo Documento:</label>
            <select name="tipoDocumentoId" id="tipoDocumentoId" (change)="mascararDocumento()"
                    formControlName="tipoDocumentoId" class="form-control"
                    [ngClass]="{'is-invalid': formCadastrar.get('tipoDocumentoId')?.errors
                    && formCadastrar.get('tipoDocumentoId')?.touched || formCadastrar.get('tipoDocumentoId')?.value == 0  && formCadastrar.get('tipoDocumentoId')?.touched}">
              <option value="0" disabled selected hidden> Selecione o tipo de documento</option>
              <option *ngFor="let item of tipoDocumentosCliente" value="{{item.id}}">{{ item.descricao }}</option>
            </select>
          </div>
          <div class="form-group col-md-7">
            <label for="documento">Documento:</label>
            <input type="text" id="documento" [mask]="mascaraDocumento"
                   placeholder="Digite o documento do cliente/empresa."
                   (change)="buscarClientePorDocumento()"
                   [ngClass]="{'is-invalid': formCadastrar.get('documento')?.errors
                   && formCadastrar.get('documento')?.touched || clienteExistente}"
                   formControlName="documento" class="form-control">
          </div>
        </div>
      </form>
      <div class="row">
        <div class="card" style="padding: 20px;margin-top: 20px;margin-left: 2px">
          <form [formGroup]="formContatos" id="formContatos">
            <div class="row">
              <div class="form-group col-md-5">
                <label for="telefone">Telefone:</label>
                <input type="text" id="telefone"
                       mask="(00) 00000-0000"
                       placeholder="Digite o telefone do cliente/empresa."
                       [ngClass]="{'is-invalid': formContatos.get('telefone')?.errors && formContatos.get('telefone')?.touched
                       || validarTelefoneJaExistente()}"
                       formControlName="telefone" class="form-control">
              </div>
              <div class="form-group col-md-6">
                <label for="email">Email:</label>
                <input type="email" id="email"
                       placeholder="Digite o email do cliente/empresa."
                       [ngClass]="{'is-invalid': formContatos.get('email')?.errors && formContatos.get('email')?.touched
                        || validarEmailJaExistente()}"
                       formControlName="email" class="form-control">
              </div>
              <div class="col-md-1" style="padding-top: 10px;margin-top: 13px;">
                <button class="btn btn-primary" (click)="adicionarContato()"><i class="fa fa-plus-circle"></i></button>
              </div>
            </div>
            <div class="row font-menor">
              <table class="table table-striped table-bordered" style="margin-top: 10px;">
                <thead>
                  <tr>
                    <th>Telefone</th>
                    <th>Email</th>
                    <th>*</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of contatos; let i = index" [ngClass]="{'active': i == 0}">
                    <td>{{item.descricao}}</td>
                    <td>{{item.email}}</td>
                    <td><button class="btn btn-warning" (click)="removerContato(item.descricao)"><i class="fa fa-minus-square"></i></button></td>
                  </tr>
                  <tr *ngIf="contatos.length <= 0">
                    <td colspan="3" style="text-align: center;">Nenhum contato cadastrado</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
          <button class="btn btn-warning" (click)="fecharModal()">Cancelar</button>
        </div>
        <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
          <button class="btn btn-primary" (click)="salvar()" [disabled]="formCadastrar.invalid || contatos.length <= 0">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</div>
